/**
 * Source-highlight styling, shared by the attachment viewer and the mail-body
 * highlighter so the two surfaces read as one feature (STK-1360/STK-1811).
 *
 * Fixed, unlike the delineation overlays: this color never encodes flow
 * status. Matches the photo/PDF band treatment.
 */
export const HIGHLIGHT_BG = "rgba(251, 191, 36, 0.15)";
export const HIGHLIGHT_OUTLINE = "1px solid rgba(245, 158, 11, 0.5)";
